import { Button } from "@jhool-io/fe-components";
import useAuthContext from "../../../../hooks/useAuthContext";

interface IncompleteAccountStateProps {
    actionLabel?: string;
    onActionClick?: () => void;
}

export default function IncompleteAccountView({
    actionLabel,
    onActionClick,
}: IncompleteAccountStateProps) {
    const { logOutUser } = useAuthContext();

    const handleAction = () => {
        if (onActionClick) {
            onActionClick();
            return;
        }

        logOutUser().catch(() => undefined);
    };

    return (
        <main className="min-h-dvh flex items-center justify-center px-16 py-24">
            <section className="w-full max-w-[500px] text-center flex flex-col items-center">
                <p className="text-[30px] font-medium text-black mb-8">
                    Account setup needs attention
                </p>
                <p className="text-base text-gray mb-32">
                    We could not find an active practice or client profile
                    linked to this account. Please contact your practice or
                    billing support so they can finish setting up your portal
                    access.
                </p>
                <Button
                    className="self-center"
                    variant="primary"
                    onClick={handleAction}
                    size="medium"
                >
                    {actionLabel ?? "Sign out"}
                </Button>
            </section>
        </main>
    );
}
